<template>
  <v-container fluid>

    <v-row
      class="fill-height"
      align="center"
      justify="center"
      v-for="(priority, idx) in domain_priorities" :key="idx"
    >
      <v-col sm="12" class="d-flex">
        <span class="text--disabled">Priority {{ priority }}</span>
        <v-divider class="ms-3 mt-3"></v-divider>
      </v-col>
      <template  v-for="(item, i) in empty_domains.filter(dom => !!(active_domains.find(d => d.domain_id === dom.domain_id)) && active_domains.find(d => d.domain_id === dom.domain_id).isActive && dom.priority === priority)" >
        <v-col
          :key="i"
          cols="12"
          md="2"
        >
              <!-- :color="(item.label_id.includes(0)) ? 'grey darken-3' : 'grey darken-4'" -->
            <v-card
              :color="(
                !!(active_domains.find(d => d.domain_id === item.domain_id)) &&
                active_domains.find(d => d.domain_id === item.domain_id).isActive
                ) ? 'grey darken-3' : 'grey darken-4'"
            >
              <v-card-title class="d-flex justify-space-between body-2">
                  <span>{{ item.domain_name }}</span>
                  <v-icon v-if="!!(active_domains.find(d => d.domain_id === item.domain_id)) && active_domains.find(d => d.domain_id === item.domain_id).isActive" @click="cancel_domain(item, false)">close</v-icon>
                  <v-icon v-else @click="cancel_domain(item, true)">done</v-icon>
              </v-card-title>
              <v-card-text class="d-none">
                    <v-btn-toggle
                      v-model="item.label_id"
                      dense
                      multiple
                      class="d-flex flex-column"
                      :class="(
                        !!(active_domains.find(d => d.domain_id === item.domain_id)) &&
                        (active_domains.find(d => d.domain_id === item.domain_id).isActive)
                        ) ? 'grey darken-3' : 'grey darken-4'"
                    >
                      <v-btn
                        v-for="label in labels.filter(l => l.label_id > 0)" :key="label.label_id"
                        class="mx-auto my-1 subtitle-2"
                        active-class="active-button"
                        text
                        :value="label.label_id"
                        :color="label.color"
                        :disabled="!!(active_domains.find(d => d.domain_id === item.domain_id)) && !active_domains.find(d => d.domain_id === item.domain_id).isActive"
                        small
                        @click="select_label(item, label.label_id)"
                      >{{ label.title }}</v-btn>
                        <!-- :text="!item.label_id.includes(label.label_id)" de doulevei -->
                    </v-btn-toggle>
              </v-card-text>
            </v-card>
        </v-col>
      </template>
    </v-row>
    <v-row class="mb-10">
      <template  v-for="(item, i) in empty_domains.filter(dom => (active_domains.find(d => d.domain_id === dom.domain_id)) && !active_domains.find(d => d.domain_id === dom.domain_id).isActive )" >
        <v-col
          :key="i"
          cols="12"
          md="2"
        >
          <v-card
              :color="(
                !!(active_domains.find(d => d.domain_id === item.domain_id)) &&
                active_domains.find(d => d.domain_id === item.domain_id).isActive
                ) ? 'grey darken-3' : 'grey darken-4'"
            >
              <v-card-title class="d-flex justify-space-between body-2">
                  <span>{{ item.domain_name }}</span>
                  <v-icon v-if="(active_domains.find(d => d.domain_id === item.domain_id)) && active_domains.find(d => d.domain_id === item.domain_id).isActive" @click="cancel_domain(item, false)">close</v-icon>
                  <v-icon v-else @click="cancel_domain(item, true)">done</v-icon>
              </v-card-title>
            </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
<!-- https://v2.vuetifyjs.com/en/components/hover/#transition -> Misc hover list -->
</template>

<script>
/* eslint-disable */
import { exractProductDomains } from "@/helpers/functions.js";

export default {
  name: "N_EmptyDomainsTable",
  components: { },
  props: {
    size_of_table: {
      type: Number || Boolean,
      default: 0,
      required: false,
    },
  },
  data: () => ({
    product_labels: [],
    labels: [],
    headers: [
      {
        text: "Domain",
        align: "start",
        value: "domain_name",
      },
      { text: "Actions", value: "actions", sortable: false, align: "start", },
      // { text: "Color", value: "color", sortable: false, align: "start", },
    ],
    list_belong_to_client_id: null,
    active_domains: [],
  }),
  computed: {
    selectedProductSpecs() {
      return this.$store.state.productionModule.selected_product.specs;
    },
    clients() {
      return this.$store.getters["productionModule/selected_product_clients_names"];
    },
    clients_ids() {
      return this.$store.getters["productionModule/selected_product_clients_ids"];
    },
    selected_product() {
      return this.$store.state.productionModule.loaded_products.find(
        (x) =>
          x.product_id ===
          this.$store.state.productionModule.selected_product.id
      );
    },
    selected_urls_of_product: {
      get() {
        return this.$store.state.productionModule.selected_urls_of_product;
      },
      set(value) {
        const data = {
          key: "selected_urls_of_product",
          value: value,
        };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
    product_urls() {
      return this.exractProductDomains(
        this.$store.state.productionModule.selected_product.specs.product_domains
      );
    },
    domains() { return this.$store.state.productionModule.domains; },
    selected_client() { return this.$store.state.productionModule.product_filter.selected_client; },
    valids_domains() {
      return this.$store.state.productionModule.valid_domains_urls.map(d => d.domain_id);
    },
    client_domains() {
      let ret_domains = [];
      if(!!parseInt(this.selected_client)){ //boolean selected_client_id
        ret_domains = this.$store.state.productionModule.clients_list.find(cl => cl.value == this.selected_client).domains ;
      }else{
        const unique_domains = new Set();
        let filtered_clients = this.$store.state.productionModule.clients_list.filter(cl => this.clients_ids.includes(cl.value));
        filtered_clients.forEach(client => {
          client.domains.forEach(domain => {
            unique_domains.add(domain);
          })
        });
        ret_domains = [...unique_domains];
      }
      return ret_domains
                //.filter(d => !!d.priority) // filter domains return what is not auto - is manual
                // .map(d => d.domain_id); // map the array with domain ids only
    },
    empty_domains() {
      const unique_domains = new Set(this.product_urls.map(u => parseInt(u.domain_id)));
      // const client_domains_only = this.client_domains.map(d => d.domain_id);
      return  this.client_domains
                .filter(d => !(unique_domains.has(d.domain_id) || this.valids_domains.includes(d.domain_id)))
                .map((empty_domain, i) => ({
                  domain_id: empty_domain.domain_id,
                  domain_name: this.domains.find(d => d.id == empty_domain.domain_id).domain.replace("https://", "").replace("http://", "").replace("www.", ""),
                  url: '',
                  label_id: this.product_labels.filter(l => l.domain_id == empty_domain.domain_id ).map(m => m.label_id),
                  priority: empty_domain.priority,
                  isActive: !this.product_labels.filter(l => l.domain_id == empty_domain.domain_id ).map(m => m.label_id).includes(0),
                  index: i,
                })).sort(this.sortDomains)
    },
    domain_priorities () {
      const priorities = new Set(this.empty_domains.map(d => d.priority));
      return [...priorities]
    },
    product_status: {
      get() {
        return this.$store.state.productionModule.selected_product.status;
      },
      set(value) {
        this.$store.commit("productionModule/SET_SELECTED_PRODUCT_STATUS", value);
      }
    },

    statusColor() {
      return 'red';
    },
    sync_status () {
      return this.$store.state.productionModule.sync_status;
    },
  },
  methods: {
    sortDomains(a, b) {
      let aName = a.domain_name
      let bName = b.domain_name
      // if()
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    },
    exractProductDomains,
    change_product_status() {
      this.loading = true;
      const prod_id = this.$store.state.productionModule.selected_product.id;
      const data = {
        task: "change_product_status",
        payload: {
          product_id: prod_id,
          status: this.product_status,
          }
      };
      this.$store.dispatch("productionModule/general_api", data)
      .then( res => {
        this.
        console.log( 'find_product_status results', res.data );
        this.product_status = res.data.payload.status;
        const obj = {id: prod_id, status: this.product_status};
        this.$store.commit("productionModule/UPDATE_LOADED_PRODUCTS_STATUS", obj);
      }).finally(() => { this.loading = false });
    },

    decode_url(url){
      try {
        const new_url = decodeURI(url);
        return new_url;
      } catch (error) {
        return url;
      }
    },
    get_empty_urls_labels() {
      const payload = {
        task: "get_urls_labels",
        payload: {
          product_id: parseInt(this.$store.state.productionModule.selected_product.id),// this.delete_dialog.item.product_id,
        },
      };
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          this.labels = res.data.labels;
          this.product_labels = res.data.product_labels;
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    select_label(item, label_id) {
      const payload = {
        task: 'saveEmptyUrlsLabels',
        payload: {
          product_id: this.selected_product.product_id,
          domain_id: item.domain_id,
          label_id,
        }
      }
      this.$store.dispatch("productionModule/general_api", payload)
    },
    create_empty_domains_disable() {

    },
    cancel_domain (item, value) {
      // console.log('item 1', structuredClone(item))
      // const index = this.empty_domain.findIndex(d => d.domain_id === item.domain_id)
      // this.empty_domain
      // console.log('item 2', structuredClone(item))
      this.active_domains.find(d => d.domain_id === item.domain_id).isActive = value
      this.select_label(item, 0)
    },
    createDisableDomains() {
      this.active_domains = [];
      this.active_domains = this.empty_domains.map(x => ({
        domain_id: x.domain_id,
        priority: x.priority,
        isActive: x.isActive,
      }))
    },
  },
  mounted() {
    this.createDisableDomains();
    this.create_empty_domains_disable();
    this.get_empty_urls_labels();
  },
  watch: {
    "selected_product"(newProduct, oldProduct) {
      if (newProduct && newProduct !== oldProduct) {
        this.get_empty_urls_labels();
      }
    },
    "empty_domains"(newDomains, oldDomains) {
      if (newDomains && newDomains !== oldDomains) {
        this.createDisableDomains();
      }
    },
  },
};
</script>

<style scoped>
.status-select{
  width: 18px;
}
.active-button{
  background-color: #BDBDBD;
}

.v-card {
  transition: opacity .4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.6;
 }

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/production/N_EmptyDomainsTable.vue